import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, Output, SimpleChanges } from '@angular/core';
import {FormControl, FormGroup, FormBuilder} from '@angular/forms';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import config from 'config/default.json';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';

@Component({
  selector: 'app-vcl-filter',
  templateUrl: './vcl-filter.component.html',
  styleUrls: ['./vcl-filter.component.scss']
})
export class VcFilterComponent {
  constructor(
    private elRef:ElementRef,
    private cdRef: ChangeDetectorRef,
    private apiService: ApiServiceModule,
    private helper: HelperModule,
    private sharedService: SharedService,
    private zone: NgZone
    ) {}
    countryControl = new FormControl();
    cycleControl = new FormControl();
    regionControl = new FormControl();
    institutionControl = new FormControl();
    classControl = new FormControl();
    studyControl = new FormControl();
    modeControl = new FormControl();
    searchControl = new FormControl();
  
    filteredInstitutions: { [x:string]: string|number|boolean }[] = [];
    filteredStudies: { [x:string]: string|number|boolean }[] = [];
    searchInstitutionControl = new FormControl();
    searchStudyControl = new FormControl();

    countries: { [x:string]: string|number|boolean }[] = [];
    cycles: { [x:string]: string|number|boolean }[] = [];
    regions: { [x:string]: string|number|boolean }[] = [];
    institutions: { [x:string]: string|number|boolean }[] = [];

    classes: { [x:string]: string|number|boolean }[] = [];
    studies: { [x:string]: string|number|boolean }[] = [];
  
    selectedCountry: any = null;
    selectedCycle: any = null;
    selectedRegion: any = null;
    selectedInstitution: any = null;

    selectedClass: any = null;
    selectedStudy: any = null;
  
    userFilter: any = new Map();
    
    @Input() userInfos: { [x:string]: any } = new Map();
    @Input() modes:any[] = [];
    @Input() filterType!: string;
  
    @Input() pageId!: string;
    @Input() pageName?: string | undefined;
    @Input() hasSearchKey?: boolean | undefined;
    @Input() platformInfos:any;
    @Output() filterDataOutputEvent = new EventEmitter<any>();

    showDepartment!: boolean;
  
    ngOnInit(){
      console.log(this.filterType);
      this.fillFilter();
      this.applySearch();
    }
    ngOnChanges(changes: SimpleChanges): void {
      if (changes['userInfos'] && !changes['userInfos'].firstChange) {
        this.fillFilter();
        this.applySearch();
        this.cdRef.detectChanges();
      }
    }
    fillFilter(){
      let userNavigationInfos = this.userInfos['navigation_infos'];
      this.userFilter = userNavigationInfos && userNavigationInfos["vcl_filter_"+this.pageId]? userNavigationInfos["vcl_filter_"+this.pageId]: {};
      this.userFilter['key_update'] = "vcl_filter_"+this.pageId;
      this.userFilter['id_user'] = this.userInfos['id_user'];
      
      this.selectedCountry = this.userFilter.country || null;
      this.selectedCycle = this.userFilter.cycle || null;
      this.selectedRegion = this.userFilter.region || null;
      this.selectedInstitution = this.userFilter.vcl_institution || null;

      this.selectedClass = this.userFilter.class || null;
      this.selectedStudy = this.userFilter.study || null;
      this.loadPreviousFilter();
      
    }
    loadPreviousFilter(){
      this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/load_previous_filter', {user_filter: this.userFilter, filter_type: this.filterType}, this.userInfos['access_token']).subscribe((response:any)=>{
        this.countries = response.country;
        this.cycles = response.cycle
        this.regions = response.region;
        this.institutions = response.vcl_institution;

        this.classes = response.class;
        this.studies = response.study;

        this.filteredInstitutions = this.institutions;
        this.filteredStudies = this.studies;

        this.countryControl.setValue(this.selectedCountry);
        this.cycleControl.setValue(this.selectedCycle);
        this.regionControl.setValue(this.selectedRegion);
        this.institutionControl.setValue(this.selectedInstitution);
        this.classControl.setValue(this.selectedClass);
        this.studyControl.setValue(this.selectedStudy);
        this.modeControl.setValue(this.userFilter.mode || null);
        this.chargeData();
      });
    }
    applySearch(){
      this.searchInstitutionControl.valueChanges.subscribe((text) => {
        return this.filteredInstitutions = this.institutions.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
      });
      this.searchStudyControl.valueChanges.subscribe((text) => {
        return this.filteredStudies = this.studies.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
      });

    }
    normalizeString(str:any){
      return str.toString().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")
    }
    
    updateRegion(){
      this.userFilter.country = this.countryControl.value || null;
      this.cycleControl.setValue(null);
      this.regionControl.setValue(null);
      this.institutionControl.setValue(null);

      this.userFilter.cycle = null;
      this.userFilter.region = null;
      this.userFilter.vcl_institution = null;
      this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/region', this.userFilter, this.userInfos['access_token']).subscribe((data:any)=>{
        this.regions = data;
      });
    }
    updateInstitutionOrClass(lastTable:string){
      if(this.filterType == 'institution'){
        this.userFilter.cycle = this.cycleControl.value || null;
        this.userFilter.region = this.regionControl.value || null;
        this.userFilter.last_table = lastTable
        this.institutionControl.setValue(null);

        this.userFilter.vcl_institution = null;
        this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/institution', this.userFilter, this.userInfos['access_token']).subscribe((data:any)=>{
          this.institutions = data;
          this.filteredInstitutions = this.institutions;
        });
      }
      if(this.filterType == 'study'){
        this.userFilter.country = this.countryControl.value || null;
        this.userFilter.cycle = this.cycleControl.value || null;
        this.userFilter.last_table = lastTable
        this.classControl.setValue(null);
        this.studyControl.setValue(null);

        this.userFilter.class = null;
        this.userFilter.study = null;
        this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/class', this.userFilter, this.userInfos['access_token']).subscribe((data:any)=>{
          this.classes = data;
        });
      }
    }
    updateStudy(lastTable:string){
      this.userFilter.country = this.countryControl.value || null;
      this.userFilter.cycle = this.cycleControl.value || null;
      this.userFilter.class = this.classControl.value || null;
      this.userFilter.last_table = lastTable;
      this.studyControl.setValue(null);
      this.userFilter.study = null;

      this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/study', this.userFilter, this.userInfos['access_token']).subscribe((data:any)=>{
        this.studies = data;
        this.filteredStudies = this.studies;
      });
    }
    setInstitution(){
      this.userFilter.vcl_institution = this.institutionControl.value || null;
      this.userFilter.last_table = 'vcl_institution'
      this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/save_user_navigation', this.userFilter, this.userInfos['access_token']).subscribe((response:any)=>{
      });
    }
    setStudy(){

    }
    setMode(){
      this.userFilter['key_mode'] = this.modeControl.value;
      this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/save_user_navigation', this.userFilter, this.userInfos['access_token']).subscribe((response:any)=>{
        });
    }
    loadPreviousFilters(){
      console.log(this.userFilter)
    }
  
    selectedElement(selectedOptions: FormControl, element: { [x:string]: string|number|boolean }): boolean {
      return Array.isArray(selectedOptions.value) && selectedOptions.value.includes(element['id']);
    }
  
    chargeData() {
      let countryValue = this.countryControl.value;
      let selectedData:any = {
        country: this.countries.find((el:any)=> countryValue == el['id']),
        cycle: this.cycles.find((el:any)=> this.cycleControl.value == el['id']),
        region: this.regions.find((el:any)=> this.regionControl.value == el['id']),
        vcl_institution: this.institutions.find((el:any)=> this.institutionControl.value == el['id'])
      };
      let data = {
        filter_data: selectedData,
        filter_values: {
          id_country: countryValue || null,
          id_cycle: this.cycleControl.value || null,
          id_region: this.regionControl.value || null,
          id_vcl_institution: this.institutionControl.value|| null,
          id_class: this.classControl.value || null,
          id_study: this.studyControl.value|| null
        },
        mode: this.modeControl.value? this.modeControl.value: [],
        search_key: this.searchControl.value,
        limit: 500, offset: 0,
        platform_infos: this.platformInfos
      }
      if(countryValue && Object.keys(data).length > 0)this.filterDataOutputEvent.emit(data);
      
    }
}
